import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"
import { kebabCase } from "lodash"
import * as styles from "../../styles/nextroutecard.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMotorcycle } from "@fortawesome/free-solid-svg-icons"

const NextRouteCard = ({
  slug,
  timeFrom,
  label = "Next Route!",
  isSlim = false,
}) => {
  const data = useStaticQuery(graphql`
    query {
      allMdx {
        nodes {
          fields {
            slug
          }
          frontmatter {
            title
            description
            area
            category1
            category2
            hero {
              childImageSharp {
                gatsbyImageData(
                  width: 600
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
    }
  `)

  const post = data.allMdx.nodes.find(node => node.fields.slug.includes(slug))

  if (!post) return null

  const image = getImage(post.frontmatter.hero)

  return (
    <motion.div
      whileHover={{ x: 5 }}
      className={`${styles.cardWrapper} ${isSlim ? styles.slimCard : ""}`}
    >
      <Link
        to={`/${kebabCase(post.frontmatter.category1)}/${kebabCase(
          post.frontmatter.category2
        )}/${kebabCase(post.fields.slug)}`}
        className={styles.cardLink}
      >
        <div className={styles.imageSide}>
          <GatsbyImage
            image={image}
            alt={post.frontmatter.title}
            className={styles.eyecatch}
          />
          {/* 通常版（1枚目）のときだけ画像の上にラベルを表示 */}
          {!isSlim && <div className={styles.label}>{label}</div>}
        </div>

        <div className={styles.contentSide}>
          <div className={styles.meta}>
            {/* スリム版ではタイトルの横（上）に、あのオレンジ色のバッジを表示 */}
            {isSlim && <span className={styles.slimLabelBadge}>{label}</span>}

            {timeFrom && (
              <span className={styles.time}>
                <FontAwesomeIcon
                  icon={faMotorcycle}
                  className={styles.motoIcon}
                />
                <span className={styles.timeText}>ここから{timeFrom}</span>
              </span>
            )}
          </div>

          <h3 className={styles.title}>{post.frontmatter.title}</h3>

          {!isSlim && (
            <div className={styles.description}>
              {post.frontmatter.description}
            </div>
          )}
        </div>
      </Link>
    </motion.div>
  )
}

export default NextRouteCard
